import { setReceitaSolicitada } from '../../../services/receitaSolicitada';
import { isOmie } from '../../../services/globalFunctions';

export const truncateText = (value, maxLength) => {
  const text = String(value || '-').toUpperCase();
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 3)}...`;
};

export const isDisabledStatus = (status) => {
  const normalizedStatus = Number(status);
  return normalizedStatus === 2 || normalizedStatus === 3 || normalizedStatus === 4;
};


export const getStatusMeta = (status) => {
  switch (Number(status)) {
    case 2:
      return { text: 'Receita gerada', variant: 'success' };
    case 3:
      return { text: 'Receita cancelada', variant: 'error' };
    case 4:
      return { text: 'Solicitação cancelada', variant: 'error' };
    case 5:
      return { text: 'Aguardando liberação', variant: 'waiting' };
    case 1:
    default:
      return { text: 'Em aberto', variant: 'default' };
  }
};

export const formatQuantidade = (data) => {
  const src = (data && typeof data === 'object' && 'quantidade_adquirir' in data && 'unidade_quantidade_adquirir' in data)
    ? data
    : (Array.isArray(data?.agro_prescriptions_relations_orders) ? data.agro_prescriptions_relations_orders[0] : null);

  if (!src) return "";

  const q = src.quantidade_adquirir;
  const u = src.unidade_quantidade_adquirir;

  if (q == null || u == null) return "";

  return `${String(q).replace(".", ",")} ${u}`;
};

export const formatarData = (dataISO) => {
  const mesesAbreviados = [
    "JAN",
    "FEV",
    "MAR",
    "ABR",
    "MAI",
    "JUN",
    "JUL",
    "AGO",
    "SET",
    "OUT",
    "NOV",
    "DEZ",
  ];

  const data = new Date(dataISO);
  const dia = data.getUTCDate();
  const mes = mesesAbreviados[data.getUTCMonth()];
  const ano = data.getUTCFullYear();

  return `${dia} ${mes} ${ano}`;
};

export const formatLocal = (item) => {
  const uf = item?.local_aplicacao_estado || "-";
  const local = item?.local_aplicacao_nome || "-";
  return `${uf}: ${local}`;
};

export const getProducts = (item) => (
  Array.isArray(item?.agro_prescriptions_relations_orders) && item.agro_prescriptions_relations_orders.length > 0
    ? item.agro_prescriptions_relations_orders
    : [item]
);

// Mesmos campos obrigatórios usados no ícone de atenção da tela de Solicitações de
// Receitas (tableSolicitacao) - duplicado aqui de propósito, não importado de lá, pra não
// criar acoplamento entre os dois componentes.
const PRODUTOR_CAMPOS_OBRIGATORIOS = ['nome', 'cpf_cnpj', 'telefone', 'cep', 'logradouro', 'numero', 'bairro', 'cidade'];
const FAZENDA_CAMPOS_OBRIGATORIOS = ['nome', 'cpf_cnpj', 'cep', 'endereco', 'numero', 'bairro', 'cidade', 'estado', 'cod_ibge'];

export const isProdutorIncompleto = (produtor) =>
  !produtor || PRODUTOR_CAMPOS_OBRIGATORIOS.some((campo) => !produtor[campo]);

export const isFazendaIncompleta = (fazenda) =>
  !!fazenda && FAZENDA_CAMPOS_OBRIGATORIOS.some((campo) => !fazenda[campo]);

export const isCadastroIncompleto = (item) =>
  isOmie() && item?.status === 1 && (isProdutorIncompleto(item?.agro_producers) || isFazendaIncompleta(item?.agro_farms));

// produto_apto_estado é calculado 1x na criação do rascunho (ver criarRascunho no
// omie.service.ts) - aqui só lê o flag já pronto, sem chamar compêndio de novo.
export const produtosIncompativeisComEstado = (item) =>
  (item?.agro_prescriptions_relations_orders || []).filter(
    (produto) => produto?.produto_apto_estado === false,
  );

export const isProdutoIncompativelComEstado = (item) =>
  isOmie() && item?.status === 1 && produtosIncompativeisComEstado(item).length > 0;

// Pedido veio da Omie sem CNPJ de entrega - rascunho criado sem fazenda vinculada (ver
// criarRascunho no omie.service.ts, local_aplicacao_nome fica '' nesse caso, sem
// fallback pro estado da subsidiária). Usuário resolve escolhendo uma fazenda existente
// do produtor (ModalVincularFazenda).
export const isFazendaAusente = (item) =>
  isOmie() && item?.status === 1 && !item?.local_aplicacao_nome;

// Mesma ordem de checagem usada em "incompleto" nos componentes (desktop.js/mobile.js) -
// a mensagem do ícone de atenção precisa bater com o motivo real, não um texto genérico
// que só faz sentido pro caso de cadastro incompleto.
export const getMotivoAtencao = (item) => {
  if (isCadastroIncompleto(item)) {
    return 'Faltam dados obrigatórios do produtor/fazenda - clique para completar';
  }
  if (isProdutoIncompativelComEstado(item)) {
    return 'Produto não homologado para o estado da fazenda - clique para revisar';
  }
  if (isFazendaAusente(item)) {
    return 'Pedido sem fazenda vinculada - clique para selecionar uma';
  }
  return '';
};

// Se o cadastro do produtor/fazenda estiver incompleto, não manda direto pra emissão
// (ia quebrar lá) - manda pra tela de Solicitações de Receitas, que já tem o ícone/modal
// pra completar o cadastro.
export const handleSavedRecipe = (item) => {
  if (isCadastroIncompleto(item)) {
    window.location.href = '/solicitacoes-receitas';
    return;
  }

  if (isProdutoIncompativelComEstado(item)) {
    // A ação de cancelar precisa do modal completo (com botão) que só existe na tela de
    // Solicitações de Receitas - o card aqui é só resumo, manda pra lá.
    window.location.href = '/solicitacoes-receitas';
    return;
  }

  try {
    const saved = setReceitaSolicitada(item);
    localStorage.setItem('ReceitaSolicitadaReload', true);

    if (!saved) {
      console.error('Falha ao salvar ReceitaSolicitada no sessionStorage');
      return;
    }

    window.location.href = isOmie() ? '/receitas/addlote' : '/receitas/add';
  } catch (e) {
    console.error('Erro ao salvar ReceitaSolicitada no sessionStorage', e);
  }
};
